import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-176">
      {/* Full-width background image */}
      <div className="absolute inset-0" data-id="element-177">
        <img src="https://cdn.magicpatterns.com/uploads/dZ8Roj232HgCNMNue9AsoW/pexels-anntarazevich-4926666.jpg" alt="Women supporting each other" className="w-full h-full object-cover object-[center_30%] scale-110" data-id="element-178" />
        {/* Subtle overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/40 via-charcoal/30 to-charcoal/50" data-id="element-179"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-transparent" data-id="element-180"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10 text-center text-white" data-id="element-181">
        <FadeIn delay={100} data-id="element-182">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-md mb-8" data-id="element-183">
            <Sparkles className="w-4 h-4 text-purple-300" data-id="element-184" />
            <span className="text-sm font-medium tracking-wide uppercase text-white/90" data-id="element-185">
              A New Standard in Women's Wellness
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={300} data-id="element-186">
          <h1 className="text-5xl md:text-6xl lg:text-8xl font-serif text-white leading-[1.1] mb-8 tracking-tight max-w-5xl mx-auto drop-shadow-2xl" data-id="element-187">
            The Future of Women's Wellness,{' '}
            <span className="italic text-white/95" data-id="element-188">Curated Intelligently</span>
          </h1>
        </FadeIn>

        <FadeIn delay={500} data-id="element-189">
          <p className="text-lg md:text-2xl text-white/90 max-w-3xl mx-auto mb-12 font-light leading-relaxed drop-shadow-lg" data-id="element-190">
            A private digital ecosystem connecting women to trusted
            practitioners, personalized care, and intelligent wellness pathways
            — all in one seamless platform.
          </p>
        </FadeIn>

        <FadeIn delay={700} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-191">
          <a href="https://fem-connect-demo.lovable.app/auth?redirectTo=/&fbclid=PAVERFWAQyUTBleHRuA2FlbQIxMABzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAae4bSfphbEN51QtobTbyS65sNWxLa1apBvz8XwrrlisdfaZd0KwWgwLbqgw1g_aem_TTHgJEgCXa6tLi9zpuxavg" target="_blank" rel="noopener noreferrer" data-id="element-192">
            <Button variant="primary" size="lg" className="w-full sm:w-auto bg-purple-200 text-gray-700 hover:bg-purple-300 shadow-xl font-sans font-black" data-id="element-193">
              Join the Platform
            </Button>
          </a>
          <Button variant="outline" size="lg" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/20 backdrop-blur-sm bg-white/10 shadow-xl" data-id="element-194">
            Partner With Us
          </Button>
        </FadeIn>
      </div>
    </section>;
}